import { Link } from 'react-router'

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <h2 className="mb-2 text-6xl font-bold text-gray-300">404</h2>
      <p className="mb-6 text-gray-600">Page not found</p>
      <Link to="/" className="btn-primary">
        Go Home
      </Link>
    </div>
  )
}
